import { useState } from "react";
import { toast } from "sonner";
import { apiError, http } from "@/lib/api";

export default function AdminAccount({ user }) {
  const [f, setF] = useState({ current_password: "", new_password: "", confirm: "" });
  const [busy, setBusy] = useState(false);
  const set = (k) => (e) => setF({ ...f, [k]: e.target.value });
  const submit = async (e) => {
    e.preventDefault();
    if (f.new_password !== f.confirm) return toast.error("As palavras-passe novas não coincidem");
    setBusy(true);
    try {
      await http.post("/auth/change-password", { current_password: f.current_password, new_password: f.new_password });
      toast.success("Palavra-passe alterada");
      setF({ current_password: "", new_password: "", confirm: "" });
    } catch (err) { toast.error(apiError(err)); }
    setBusy(false);
  };
  return (
    <form onSubmit={submit} className="max-w-md space-y-4 rounded-2xl border border-[var(--line)] bg-white p-6" data-testid="admin-account">
      <h2 className="font-display text-2xl font-bold">A minha conta</h2>
      <p className="text-sm text-[var(--muted-ink)]">Sessão iniciada como <b>{user?.email}</b></p>
      <input required type="password" data-testid="account-current-password" className="field" placeholder="Palavra-passe atual" value={f.current_password} onChange={set("current_password")} />
      <input required minLength={8} type="password" data-testid="account-new-password" className="field" placeholder="Nova palavra-passe (mín. 8 caracteres)" value={f.new_password} onChange={set("new_password")} />
      <input required minLength={8} type="password" data-testid="account-confirm-password" className="field" placeholder="Repetir nova palavra-passe" value={f.confirm} onChange={set("confirm")} />
      <button data-testid="account-save-password" disabled={busy} className="btn-primary">{busy ? "A guardar…" : "Alterar palavra-passe"}</button>
    </form>
  );
}
